import type { ErrorCode, FieldError } from '@miyuki/types';

/**
 * Errores de dominio. Son agnósticos del transporte: la capa de API
 * los traduce a HTTP usando `code`.
 */
export abstract class DomainError extends Error {
  abstract readonly code: ErrorCode;

  constructor(message: string, options?: { cause?: unknown }) {
    super(message, options);
    this.name = new.target.name;
  }
}

export class ValidationError extends DomainError {
  readonly code = 'VALIDATION_ERROR';

  constructor(
    message: string,
    readonly fieldErrors: readonly FieldError[] = [],
  ) {
    super(message);
  }
}

export class NotFoundError extends DomainError {
  readonly code = 'NOT_FOUND';

  constructor(resource: string, id: string) {
    super(`No se encontró ${resource} con id "${id}"`);
  }
}

export class ConflictError extends DomainError {
  readonly code = 'CONFLICT';
}

export class ForbiddenError extends DomainError {
  readonly code = 'FORBIDDEN';
}

export function isDomainError(error: unknown): error is DomainError {
  return error instanceof DomainError;
}
